export default __webpack_public_path__ + "static/media/agent-role-other-grey.39d63a46.svg";